<div id="DivAddData" class="modal" >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{title}}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideAddData()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="card">
            <div class="form-group">
              <div class="row">
                <div class="col-sm-4">
                  <label>Journal</label><span class="required">*</span>
                  <select id="ddlJournals" class="form-control ddlselect" onchange="$('#btnGetVolIssArt').trigger('click');">
                    <option value=0>Select</option>
                    <option *ngFor="let item of journalList" value={{item.ID}}>
                      {{item.Acronym}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label>Issue</label>
                  <select id="ddlIssue" class="form-control ddlselect">
                    <option value=0>Select</option>
                    <option *ngFor="let item of issueList" value={{item.IssueId}}>
                      {{item.VolIssue}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label>Article</label>
                  <select id="ddlArticle" class="form-control ddlselect">
                    <option value=0>Select</option>
                    <option *ngFor="let item of articleList" value={{item.ArticleId}}>
                      {{item.ArticleNo}}
                    </option>
                  </select>
                </div>
              </div>
              <br /><hr /><br />
              <div class="row">
                <div class="col-sm-4">
                  <button type="button" id="btnDefectCategory" (click)="GetDefectCategoryList()" style="display:none">
                    Get
                  </button>
                  <label>Defect Area</label><span class="required">*</span>
                  <select id="ddlDefectArea" class="form-control ddlselect" onchange="$('#btnDefectCategory').trigger('click');">
                    <option value=0>Select</option>
                    <option *ngFor="let item of DefectAreaList" value={{item.Id}}>
                      {{item.AreaName}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label>Defect Category</label><span class="required">*</span>
                  <select id="ddlDefectCategory" class="form-control ddlselect">
                    <option value=0>Select</option>
                    <option *ngFor="let item of DefectCategoryList" [selected]="item.Id==CategoryIdPop" value={{item.Id}}>
                      {{item.Category}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <label>Defect Instruction</label><span class="required">*</span>
                  <select id="ddlDefectInstruction" class="form-control ddlselect">
                    <option value=0>Select</option>
                    <option *ngFor="let item of DefectInstructionList" value={{item.Id}}>
                      {{item.Instructions}}
                    </option>
                  </select>
                </div>
                <!--<div class="col-sm-2">
                  <label>Request RCA</label>
                  <select id="ddlFeedbackRequest" class="form-control ddlselect">
                    <option value=0>No</option>
                    <option value=1>Yes</option>
                  </select>
                </div>-->
                <div class="row">
                  <div class="col-sm-4" id="testfileuploadbtn" style="padding: 20px;">
                    <label>Defect File</label><br />
                    <input type="file" class="form-control" (change)="onuploadSelected($event)" id="doc_Defectuploadfile" />
                  </div>

                  <div class="col-sm-4" id="supportfilename"style="padding-top:3em;">
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light" id="Download" (click)="DefectDownloadFile()"><i class="fa fa-download"></i>&nbsp;<b>Download Uploaded file</b></button>
                  </div>

                  <div class="col-sm-4">
                    <br />
                    <label>Defect Due Date</label><span class="required">*</span>
                    <input type="date" class="form-control float-right" id="Txt_DefectDueDate" (change)="GetDueDateValidation()" [min]="minDate" [max]="maxDate">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label>Defect Description</label><span class="required">*</span>
                    <textarea class="form-control rounded-0" id="txtDescription"></textarea>
                  </div>
                </div><br /><br />
              </div>
            </div>
        
        </div>
      </div>
      <div class="modal-footer" id="textbuttonh">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" (click)="hideAddData()" id="">Cancel</button>
        <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="UpdateDefectMgt()" id="UpdateAdd">{{popUpButtonText}}</button>
      </div>
      <div id="LoadingImage">
        <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
      </div>
    </div>
  </div>
</div>



